import { Card, Typography } from '@mui/material';
import React, { CSSProperties, FC, Fragment } from 'react';
import { useTheme } from '@mui/material/styles';

interface IProps {
  multiple: boolean;
  isFirstEvent: boolean;
  isLastEvent: boolean;
  eventPassed: boolean;
  eventLive: boolean;
  startTime: string;
  children?: React.ReactNode;
}

interface IStyleProps extends IProps {
  bulletSize: number;
  timeSize: number;
}

const commonPsuedo = {
  position: 'absolute',
  content: '""',
  display: 'block',
} as CSSProperties;

const useStyles = (props: IStyleProps) => {
  const theme = useTheme();
  
  return {
    root: {
      position: 'relative !important' as const,
      width: `${props.timeSize}px !important`,
      color: `${props.eventLive ? theme.palette.text.primary : theme.palette.grey[500]} !important`,
      fontSize: '0.9rem !important',
      paddingBottom: `${theme.spacing(2)} !important`,
      '&::before': {
        ...commonPsuedo,
        content: !props.isLastEvent ? '""' : 'none',
        top: '23px !important',
        right: '9px !important',
        bottom: '0 !important',
        width: '1px !important',
        borderRightWidth: '1px !important',
        borderRightStyle: `${props.multiple ? 'dashed' : 'solid'} !important`,
        borderRightColor: 'rgba(153, 153, 153, 0.5) !important',
      },
      '&::after': {
        ...commonPsuedo,
        top: `${props.multiple ? props.bulletSize - props.bulletSize / 3 : props.bulletSize / 3}px !important`,
        right: `${props.multiple ? 0 : props.bulletSize / 4}px !important`,
        width: `${props.bulletSize}px !important`,
        height: `${props.multiple ? props.bulletSize / 2 : props.bulletSize}px !important`,
        borderRadius: `${props.multiple ? props.bulletSize / 6 : props.bulletSize}px !important`,
        backgroundColor: `${theme.palette.primary.main} !important`,
        opacity: `${props.eventPassed || (props.multiple && !props.isFirstEvent) ? 0.5 : 1} !important`,
      },
    },
    cardRoot: {
      width: `calc(100% - ${props.timeSize}px) !important`,
    },
  };
};

export const EventListItem: FC<IProps> = ({ children, ...props }) => {
  const styles = useStyles({
    ...props,
    bulletSize: 12,
    timeSize: 60,
  });

  return (
    <Fragment>
      <Typography sx={styles.root}>
        {props.isFirstEvent && props.startTime.substring(0, 5)}
      </Typography>
      <Card sx={styles.cardRoot}>{children}</Card>
    </Fragment>
  );
};
